var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "93-List",
    id: "_93-List"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 30,
    rx: 2,
    ry: 2,
    width: 30,
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    x2: 27,
    y1: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    x2: 27,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11,
    x2: 27,
    y1: 23,
    y2: 23
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.62069217604cc3d01eec3999968fb511.svg";
export { ForwardRef as ReactComponent };